module.exports = __webpack_public_path__ + "img/logo-adata.f53bd202.svg";